import {
  Activity,
  Bell,
  Building2,
  CalendarClock,
  MonitorPlay,
  Map,
  Palette,
  PlugZap,
  Puzzle,
  ScrollText,
  Server,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * Navegación del panel, en datos — mismo criterio que `sidebar-data.ts` de
 * shadcn-admin, recortado a lo que el OCC necesita: sin ítems anidados, la
 * jerarquía es plana y de dos grupos.
 */

export type NavItem = {
  title: string;
  url: string;
  icon: LucideIcon;
  /** Para el resaltado activo: además de coincidencia exacta, ¿vale con qué el path empiece por esto? */
  end?: boolean;
};

export type NavGroupData = {
  title: string;
  items: NavItem[];
};

export const sidebarData: { navGroups: NavGroupData[] } = {
  navGroups: [
    {
      title: 'Operación',
      items: [
        { title: 'Nodos', url: '/', icon: Server, end: true },
        { title: 'Vista de mapa', url: '/topology', icon: Map },
        { title: 'Sesiones activas', url: '/sesiones', icon: MonitorPlay },
      ],
    },
    {
      title: 'Administración',
      items: [
        { title: 'Jerarquía', url: '/admin/jerarquia', icon: Building2 },
        { title: 'Enrolar un nodo', url: '/admin/enrolar', icon: PlugZap },
        { title: 'Usuarios y permisos', url: '/admin/usuarios', icon: Users },
        { title: 'Plugins', url: '/admin/plugins', icon: Puzzle },
        { title: 'Tareas programadas', url: '/admin/tareas-programadas', icon: CalendarClock },
        { title: 'Notificaciones', url: '/admin/notificaciones', icon: Bell },
        { title: 'Bitácora', url: '/admin/bitacora', icon: ScrollText },
        { title: 'Branding', url: '/admin/branding', icon: Palette },
        { title: 'Estado del backend', url: '/estado', icon: Activity },
      ],
    },
  ],
};
